import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ConsultationModal from '../components/ConsultationModal';
import MaterialIcon from '../components/MaterialIcon';

const About = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Navbar setIsModalOpen={setIsModalOpen} />
      <ConsultationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

      <div className="pt-16">
        {/* Hero Section */}
        <section className="min-h-[75vh] bg-[#F1F600] flex items-center">
          <div className="container-wide px-4 sm:px-6 lg:px-8 py-16 md:py-20">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div className="space-y-8">
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C3E50] leading-tight">
                  关于<span className="text-red-500">我们</span>
                </h1>
                <p className="text-lg md:text-xl text-[#2C3E50]/80 leading-relaxed">
                  专业的教练团队，为您提供个性化的成长方案，帮助您突破自我，实现目标。
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <button
                    onClick={() => setIsModalOpen(true)}
                    className="px-8 py-4 bg-[#2C3E50] text-white rounded-lg font-medium hover:bg-[#2C3E50]/90 transition-all duration-300 group flex items-center justify-center space-x-2"
                  >
                    <span>联系平台顾问</span>
                    <MaterialIcon icon="arrow_forward" className="group-hover:translate-x-1 transition-transform duration-300" />
                  </button>
                </div>
              </div>
              <div className="relative">
                <div className="w-full h-96 bg-white rounded-2xl shadow-xl overflow-hidden">
                  <img
                    src="/images/about-hero.jpg"
                    alt="关于我们"
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.src = 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80';
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-16 bg-white">
          <div className="container-wide">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div className="space-y-6">
                <h2 className="text-3xl font-bold text-[#2C3E50]">我们的使命</h2>
                <p className="text-lg text-[#2C3E50]/80 leading-relaxed">
                  我们致力于为企业提供专业的教练服务，帮助组织和个人实现突破性成长。通过创新的教练方法和丰富的实践经验，我们帮助客户在变革中保持领先。
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="bg-gradient-to-br from-amber-100 to-yellow-50 rounded-2xl p-6">
                    <h3 className="text-xl font-bold text-[#2C3E50] mb-4">专业认证</h3>
                    <p className="text-[#2C3E50]/80">所有教练均持有国际认证</p>
                  </div>
                  <div className="bg-gradient-to-br from-amber-100 to-yellow-50 rounded-2xl p-6">
                    <h3 className="text-xl font-bold text-[#2C3E50] mb-4">创新方法</h3>
                    <p className="text-[#2C3E50]/80">结合最新教练技术</p>
                  </div>
                </div>
              </div>
              <div className="space-y-6">
                <h2 className="text-3xl font-bold text-[#2C3E50]">我们的优势</h2>
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <MaterialIcon icon="check_circle" className="text-amber-500 mr-2" />
                    <span className="text-lg text-[#2C3E50]/80">丰富的行业经验</span>
                  </li>
                  <li className="flex items-start">
                    <MaterialIcon icon="check_circle" className="text-amber-500 mr-2" />
                    <span className="text-lg text-[#2C3E50]/80">专业的教练团队</span>
                  </li>
                  <li className="flex items-start">
                    <MaterialIcon icon="check_circle" className="text-amber-500 mr-2" />
                    <span className="text-lg text-[#2C3E50]/80">定制化的服务方案</span>
                  </li>
                  <li className="flex items-start">
                    <MaterialIcon icon="check_circle" className="text-amber-500 mr-2" />
                    <span className="text-lg text-[#2C3E50]/80">持续的成长支持</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="py-16 bg-[#F1F600]/10">
          <div className="container-wide">
            <h2 className="text-3xl font-bold text-[#2C3E50] text-center mb-12">我们的价值观</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <div className="w-16 h-16 bg-amber-500 rounded-xl flex items-center justify-center mb-6">
                  <MaterialIcon icon="psychology" className="text-3xl text-white" />
                </div>
                <h3 className="text-xl font-bold text-[#2C3E50] mb-4">激发潜能</h3>
                <p className="text-[#2C3E50]/80">帮助每个人发现并发挥自己的最大潜能</p>
              </div>
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <div className="w-16 h-16 bg-amber-500 rounded-xl flex items-center justify-center mb-6">
                  <MaterialIcon icon="school" className="text-3xl text-white" />
                </div>
                <h3 className="text-xl font-bold text-[#2C3E50] mb-4">专业至上</h3>
                <p className="text-[#2C3E50]/80">以专业的态度和技能服务每一位客户</p>
              </div>
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <div className="w-16 h-16 bg-amber-500 rounded-xl flex items-center justify-center mb-6">
                  <MaterialIcon icon="groups" className="text-3xl text-white" />
                </div>
                <h3 className="text-xl font-bold text-[#2C3E50] mb-4">共同成长</h3>
                <p className="text-[#2C3E50]/80">与客户共同成长，实现双赢</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-[#F1F600]/10">
          <div className="container-wide text-center">
            <h2 className="text-3xl font-bold text-[#2C3E50] mb-6">开始您的成长之旅</h2>
            <p className="text-lg text-[#2C3E50]/80 mb-8">立即联系我们，获取专业的教练服务</p>
            <button
              onClick={() => setIsModalOpen(true)}
              className="px-8 py-4 bg-[#2C3E50] text-white rounded-lg font-medium hover:bg-[#2C3E50]/90 transition-all duration-300 group flex items-center justify-center space-x-2 mx-auto"
            >
              <span>联系平台顾问</span>
              <MaterialIcon icon="arrow_forward" className="group-hover:translate-x-1 transition-transform duration-300" />
            </button>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default About; 
